import React, { useState } from "react";
import { useHistory } from "react-router-dom";

//UI
import { Skeleton, Row, Col, Tooltip, Form } from "antd";
import { Input } from "../../Common/Input";
import { ButtonPrimary } from "../../Common/Button";
import { SearchOutlined } from "@ant-design/icons";
import {
  HomePageHeader,
  HeaderLeftItemsWrapper,
  HeaderRightItemsWrapper,
  HeaderRightItem,
} from "../../Common/UIElements";
import CustomerDropdown from "../CustomerSelect/CustomerDropdown";

const CustomerPropertiesTopBar = (props) => {
  const { updateSearchMeta, customer, setCustomer } = props;
  const history = useHistory();

  return (
    <div className="customer-properties-homepage-top-bar">
      <Skeleton loading={false} active>
        <HomePageHeader>
          <Col xxl={22} xl={22} lg={22} md={22} sm={24} xs={24}>
            <Form layout="vertical">
              <HeaderLeftItemsWrapper>
                <Col xxl={6} xl={6} lg={6} md={6} sm={24} xs={24}>
                  <Form.Item label="Customer Name (HMG)">
                    <CustomerDropdown
                      setCustomer={setCustomer}
                      customer={customer}
                    />
                  </Form.Item>
                </Col>
                <Col xxl={6} xl={6} lg={6} md={6} sm={24} xs={24}>
                  <Form.Item label=" ">
                    <Input
                      name="searchAll"
                      className="onboarding-toolbar-input"
                      prefix={<SearchOutlined />}
                      onChange={(e) => {
                        updateSearchMeta(e.target.value, "searchAll");
                      }}
                      placeholder="Search"
                      allowClear
                    />
                  </Form.Item>
                </Col>
              </HeaderLeftItemsWrapper>
            </Form>
          </Col>
          <Col xxl={2} xl={2} lg={2} md={2} sm={24} xs={24}>
            <HeaderRightItemsWrapper>
              <HeaderRightItem>
                <ButtonPrimary
                  onClick={() => {
                    history.push("/onboarding/dashboard");
                  }}
                >
                  Back to Dashboard
                </ButtonPrimary>
              </HeaderRightItem>
            </HeaderRightItemsWrapper>
          </Col>
        </HomePageHeader>
      </Skeleton>
    </div>
  );
};

export default CustomerPropertiesTopBar;
